"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getContractAdditionalDetails = getContractAdditionalDetails;
exports.getContractConsumptionDetails = getContractConsumptionDetails;
exports.getContractConsumptions = getContractConsumptions;
exports.getContracts = getContracts;
exports.getHanAccessDetails = getHanAccessDetails;
var _axios = _interopRequireDefault(require("axios"));
var _RestHelper = _interopRequireWildcard(require("../../utils/RestHelper"));
var _CacheHandler = _interopRequireDefault(require("../../utils/CacheHandler"));
var _config = _interopRequireDefault(require("../config/config"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function getContracts(token) {
  var config = token ? {
    headers: {
      'X-Ciam-Token': token
    }
  } : {};
  var auth = !token;
  return _CacheHandler.default.requestCache(function () {
    return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/partner/v0/contractaccounts?projection=withBusinessPartner"), {}, _RestHelper.default.setXClientHeader(config, _config.default.CHANNEL_CONFIG.portal), true, auth);
  }, 'contractaccounts');
}
function getContractConsumptions(contractAccountId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/consumption/v0/contractconsumptions?contractAccountId=").concat(contractAccountId), {}, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
}
function getContractConsumptionDetails(contractAccountId, contractId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/meterreading/v0/readingresults?contractAccountId=").concat(contractAccountId, "&contractId=").concat(contractId), {}, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
}
function getContractAdditionalDetails(contractAccountId) {
  var response = _CacheHandler.default.requestCache(function () {
    return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/partner/v0/contracts?contractAccountId=").concat(contractAccountId), {}, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
  }, "additionalDetails_".concat(contractAccountId));
  return {
    request: new Promise(function (resolve, reject) {
      response.then(function (responseData) {
        resolve(responseData);
      }).catch(function (err) {
        var error = err;
        if (_axios.default.isCancel(error)) {
          error.type = 'cancel';
        }
        reject(error);
      });
    })
  };
}
function getHanAccessDetails(contractAccountId, meterSerialNumber) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/smartmeter/v0/contractaccounts/").concat(contractAccountId, "/gatewayaccount/").concat(meterSerialNumber), {}, _RestHelper.default.setXClientHeader({}, _config.default.CHANNEL_CONFIG.portal));
}
var _default = exports.default = {
  getContracts: getContracts,
  getHanAccessDetails: getHanAccessDetails,
  getContractAdditionalDetails: getContractAdditionalDetails,
  getContractConsumptionDetails: getContractConsumptionDetails,
  getContractConsumptions: getContractConsumptions
};